<template>
  <v-row v-if="!isMobileFilter" class="desktop-filter-bar d-none d-sm-flex">
    <v-col cols="1" md="2" sm="4" class="desktop-filter-bar__search pl-0 pr-1">
      <p class="desktop-filter-bar__input-label">Search companies</p>
      <search-input :label="'Search companies'" v-on:searchTextEntered="handleSearch" />
    </v-col>
    <v-col cols="2" md="2" sm="3" class="desktop-filter-bar__sort pr-1">
      <p class="desktop-filter-bar__input-label">Sort by</p>
      <v-select :items="sortingData" hide-details v-model="selectedSort" @click="isActive = true" rounded dense solo>
        <template v-slot:append>
          <icon-dropdown class="toggle-up-down" :class="{'rotate':isActive}" />
        </template>
      </v-select>
    </v-col>
    <!-- <v-col class="desktop-filter-bar__category">
      <p class="desktop-filter-bar__input-label">Category</p>
      <v-select
        v-model="selectedCategory"
        :items="categoryData"
        hide-details
        label="Select"
        dense
        solo
      >
        <template v-slot:prepend-item>
          <v-list-item>
            <v-list-item-content>
              <v-text-field
                hide-details
                v-model="searchTerm"
                placeholder="Search"
                @input="searchCategory"
                class="desktop-filter-bar__category-search"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
    </v-col> -->
    <v-col class="desktop-filter-bar__rating">
      <p class="desktop-filter-bar__input-label">Top rated</p>

      <v-tabs hide-details optional class="desktop-filter-bar__rating-tabs">
        <v-tab v-for="(item, index) in tabData" :key="index" @change="handleTopRatedClick(item)">{{ item }}</v-tab>
      </v-tabs>
    </v-col>
  </v-row>

  <v-col v-else class="mobile-filter-bar">
    <v-row class="mobile-filter-bar__rating">
      <p
        class="mobile-filter-bar__input-label 
      mobile-filter-bar__input-label--rating"
      >
        Top rated
      </p>

      <v-tabs hide-details optional class="mobile-filter-bar__rating-tabs">
        <v-tab v-for="(item, index) in tabData" :key="index" @change="handleTopRatedClick(item)">{{ item }}</v-tab>
      </v-tabs>
    </v-row>

    <v-row>
      <v-divider />
    </v-row>

    <v-col class="mobile-filter-bar__sort">
      <p
        class="mobile-filter-bar__input-label 
      mobile-filter-bar__input-label--sort"
      >
        Sort by
      </p>

      <v-row>
        <v-divider />
      </v-row>
      <p
        v-for="(item, index) in sortingData"
        :key="index"
        class="mobile-filter-bar__sort--text"
      >
        {{ item }}
      </p>
      <v-row class="mobile-filter-bar__sort--last-divider">
        <v-divider />
      </v-row>
    </v-col>

    <!-- <v-col class="mobile-filter-bar__category">
      <p
        class="mobile-filter-bar__input-label 
      mobile-filter-bar__input-label--category"
      >
        By Category
      </p>
      <v-row>
        <v-divider />
      </v-row>
      <p
        v-for="(item, index) in categoryData"
        :key="index"
        class="mobile-filter-bar__category--text"
      >
        {{ item }}
      </p>
    </v-col> -->

    <div class="mobile-filter-bar__filter-button-wrapper">
      <v-btn class="mobile-filter-bar__filter-button">
        Apply {{ filterCount }} Filter
      </v-btn>
    </div>
  </v-col>
</template>

<script>
import IconDropdown from "./icons/IconDropdown.vue";
import SearchInput from "./SearchInput.vue";
export default {
  components: { SearchInput, IconDropdown },
  name: "FilterBar",
  props: {
    isMobileFilter: {
      type: Boolean
    }
  },
  data: () => ({
    isActive: false,
    sortingData: [
      "A-Z",
      "Z-A",
      "Highest price",
      "Lowest price",
      "Longest trial ",
      "Shortest trial"
    ],
    tabData: ["Canva", "Slack", "Jira", "Gitlab", "Figma"],
    categoryData: [
      "Ads",
      "Analytics",
      "Billing System",
      "CRM System",
      "Cyber Security",
      "Project Management"
    ],
    selectedTopRated: null,
    searchTerm: "",
    categorySearchTerm: "",
    categoriesCopy: [],
    selectedCategory: [],
    filterCount: 1,
    selectedSort: 'A-Z',
  }),
  mounted() {
    this.categoriesCopy = [...this.categoryData];
  },
  watch: {
    selectedSort() {
      // console.log(this.selectedSort);
      this.isActive = false;
      this.$emit("sortChanged", this.selectedSort);
    },
  },
  methods: {
    handleSearch(e) {
      this.$emit("searchTextEntered", e);
    },
    handleTopRatedClick(tab) {
      if(this.selectedTopRated === tab) {
        this.selectedTopRated = null;
        this.$emit("searchTextEntered", '');
      } else {
        this.selectedTopRated = tab;
        this.$emit("searchTextEntered", tab);
      }
    },
    searchCategory() {
      if (!this.searchTerm) {
        this.categoryData = this.categoriesCopy;
      }

      this.categoryData = this.categoriesCopy.filter(category => {
        return (
          category.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
        );
      });
    }
  }
};
</script>

<style>

.toggle-up-down {
    transition: transform .3s ease-in-out !important;  
}

.toggle-up-down.rotate {
    transform: rotate(180deg);
}

.desktop-filter-bar {
  margin: 0;
  margin: 20px 24px 14px 24px;
}
.desktop-filter-bar__search {
  flex: 1 1 319px;
}
.desktop-filter-bar__sort {
  flex: 1 1 151px;
}
.desktop-filter-bar__category {
  flex: 1 1 187px;
}
.desktop-filter-bar__rating {
  flex: 1 0 631px;
}

.desktop-filter-bar__input-label,
.mobile-filter-bar__input-label {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 6px !important;
  color: #030134;
  overflow: hidden !important;
}
.desktop-filter-bar .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #dfdfe9;
  border-radius: 8px;
}
.desktop-filter-bar .v-select__slot {
  font-size: 12px;
  color: #030134;
}
.desktop-filter-bar .v-select .v-select__selection {
  color: #030134;
}
.desktop-filter-bar .v-select__slot .v-label {
  font-size: 12px;
  color: #030134;
}
.desktop-filter-bar .mdi-menu-down.primary--text {
  color: #030134 !important;
}
.desktop-filter-bar .v-icon {
  color: #030134;
}
.v-menu__content {
  top: 172px !important;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.16);
  max-height: unset;
  scrollbar-width: none;
  border-radius: 12px !important;
}
.v-menu__content::-webkit-scrollbar {
  width: 0;
}
.desktop-filter-bar__category-search .v-input__slot input {
  border: 1px solid #ededf2;
  color: #2e2f30;
  caret-color: #2e2f30;
  border-radius: 12px;
  padding: 7px 12px;
  max-height: unset;
  font-size: 12px;
}
.desktop-filter-bar__category-search .v-input__slot::before {
  border: none !important;
}
.desktop-filter-bar__category-search .v-input__slot::after {
  border: none !important;
}
.v-list .v-list-item--active {
  /* border: 1px solid #ee6f78; */
  border-radius: 8px;
  margin: 0 4px;
}
.v-list .v-list-item--active:before {
  background-color: #ffcecd;
  opacity: 0.2;
}
.v-list .v-list-item .v-list-item__title {
  color: #2f2f40;
  z-index: 9;
}

/*--- Category ---*/
.mobile-filter-bar__category {
  padding: 0;
}

/*--- Sort ---*/

.mobile-filter-bar__sort {
  margin: 0;
  padding: 0;
}

.mobile-filter-bar__input-label--sort,
.mobile-filter-bar__input-label--category {
  margin: 0 !important;
}

.mobile-filter-bar__sort--text,
.mobile-filter-bar__category--text {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #2f2f40;
}

.mobile-filter-bar__sort--last-divider .v-divider {
  margin-top: 0px !important;
}

/*--- Rating Tabs ---*/

.desktop-filter-bar__rating .v-tabs-slider-wrapper,
.mobile-filter-bar__rating .v-tabs-slider-wrapper {
  display: none;
}

.desktop-filter-bar__rating .v-tab,
.mobile-filter-bar__rating .v-tab {
  color: inherit;
  background-color: #e6e9fc;
  border-radius: 8px;
  margin-right: 10px;
  padding: 9px 20px;
  font-size: 12px;
  color: #030134 !important;
  height: 36px;
  text-transform: capitalize;
  letter-spacing: -0.5px;
}

.desktop-filter-bar__rating .v-tab--active,
.mobile-filter-bar__rating .v-tab--active {
  border: 2px solid #4254d1;
}

.desktop-filter-bar__rating .v-tabs-bar,
.mobile-filter-bar__rating .v-tabs-bar {
  height: unset;
}

.mobile-filter-bar__input-label--rating {
  margin-bottom: 16px !important;
}

.mobile-filter-bar__rating {
  margin: 0;
}

.mobile-filter-bar__rating .v-slide-group__content {
  flex-wrap: wrap;
  width: calc(100vw - 24px);
}

.mobile-filter-bar__rating .v-tab {
  margin-bottom: 6px;
}

/* Mobile Filter Bar */
.mobile-filter-bar {
  position: absolute;
  margin: 0;
  z-index: 9;
  top: 0;
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
  background: #fff;
}
.mobile-filter-bar .v-divider {
  margin: 16px 0px;
}
.mobile-filter-bar .v-slide-group__next,
.mobile-filter-bar .v-slide-group__prev {
  display: none !important;
}
/*--- Mobile Filter Button ---*/
.mobile-filter-bar__filter-button-wrapper {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff5d5;
  box-shadow: -1px -4px 24px rgba(34, 32, 73, 0.1);
  padding: 16px 16px 12px 16px;
}
.mobile-filter-bar__filter-button.v-btn.theme--light {
  width: 100%;
  box-shadow: none;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  padding: 6px 20px;
  background-color: #f8d153 !important;
  color: #030134;
}
</style>
